import { render, staticRenderFns } from "./CommonPageSplit.vue?vue&type=template&id=7a6dfacd"
import script from "./CommonPageSplit.vue?vue&type=script&lang=js"
export * from "./CommonPageSplit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports